import React from 'react'
import Navbars from '../Navbars'
import Sidebar from '../profile/Sidebar'
import "./Wallet.css"
import { Payment } from '../posting/Socialarray'
import { Payments } from '../posting/Socialarray'
import { Payment1 } from '../posting/Socialarray'
import { Payment2 } from '../posting/Socialarray'
import WalletTabs from './WalletTabs'
import { useNavigate } from 'react-router-dom'


function Wallet() {
    const Navigate = useNavigate()
    const movepage = () => {
        Navigate("/payment")
    }
    return (<>
        <div className='conatiner-fluid' style={{ backgroundColor: "#F5F5F5",height:"100vh" }}>
            <Navbars />
            <div className='d-flex gap-5 pe-3 main_div'>
                <Sidebar />
                <div className='inner_div  mb-4  pt-2 ps-3 pe-3 pb-4' style={{ backgroundColor: "white",marginTop:"85px" }}>
                    <p className='payment_mainheading'>Select a Plan</p>
                    <div className='mb-5 mt-5 wallet_tab_div'>
                        <WalletTabs />
                    </div>
                    <div className='row '>
                        <div className='col-lg-6 col-md-12 col-sm-12 mt-3'>
                            <div className='payment_card'>
                                <div className='d-flex justify-content-between gap-2 flex-wrap align-items-center'>
                                    <p className='payment_heading'>Professional</p>
                                    <p className='payment_heading2'>$12.00/month</p>
                                </div>
                                <p className='payment_text'>All the features in Free, plus the following, to help you scale your social media
                                    efforts.</p>
                                <div className='border_data'></div>
                                <div className='row'>
                                    <div className='col-lg-6 col-md-6 col-sm-12 pt-3'>
                                        {
                                            Payment.map((item) => {
                                                return (<>
                                                    <div className='d-flex gap-1 align-items-center mt-3'>
                                                        <img src={item.img} />
                                                        <p className='payment_title'>{item.title}</p>
                                                    </div>



                                                </>)
                                            })
                                        }

                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-12 pt-3'>
                                        {
                                            Payments.map((item) => {
                                                return (<>
                                                    <div className='d-flex gap-1 align-items-center mt-3'>
                                                        <img src={item.img} />
                                                        <p className='payment_title'>{item.title}</p>
                                                    </div>



                                                </>)
                                            })
                                        }
                                    </div>
                                </div>
                                <div className='d-flex justify-content-center' style={{ marginTop: "40px" }}>
                                    <button className='select_btn' onClick={movepage}>Select</button>
                                </div>

                            </div>
                        </div>
                        
                        <div className='col-lg-6 col-md-12 col-sm-12 mt-3'>
                            <div className='payment_card1'>
                                <div className='d-flex justify-content-between gap-2 flex-wrap align-items-center'>
                                    <p className='payment_heading'>Business</p>
                                    <p className='payment_heading2'>$21.00/month</p>
                                </div>
                                <p className='payment_text'>All the features in Free, plus the following, to help you scale your social media
                                    efforts.</p>
                                <div className='border_data'></div>
                                <div className='row'>
                                    <div className='col-lg-6 col-md-12 col-sm-12 pt-3'>
                                        {
                                            Payment1.map((item) => {
                                                return (<>
                                                    <div className='d-flex gap-1 align-items-center mt-3'>
                                                        <img src={item.img} />
                                                        <p className='payment_title'>{item.title}</p>
                                                    </div>



                                                </>)
                                            })
                                        }

                                    </div>
                                    <div className='col-lg-6 col-md-12 col-sm-12 pt-3 '>
                                        {
                                            Payment2.map((item) => {
                                                return (<>
                                                    <div className='d-flex gap-1 align-items-center mt-3'>
                                                        <img src={item.img} />
                                                        <p className='payment_title'>{item.title}</p>
                                                    </div>



                                                </>)
                                            })
                                        }
                                    </div>
                                </div>
                                <div className='d-flex justify-content-center' style={{ marginTop: "40px" }}>
                                    <button className='select_btn' onClick={movepage} style={{ backgroundColor: "rgba(45, 156, 219, 1)", color: "white" }}>Select</button>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>






    </>

    )
}

export default Wallet